const { default: styled } = require('styled-components');

const FixedFooter = styled.div`
  position: fixed;
  z-index: 10;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--colorBgContainer);
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: ${({ align }) => align || 'right'};
  box-shadow: 0 -1px 4px 0 rgba(0, 21, 41, 0.12);
`;

export default FixedFooter;
